import React from 'react';

const ProfileCard = ({ name,firstName,lastName, role, email, image }) => {
  return (
    <div className="flex items-center p-4 pl-0  max-w-md ">
      {image?<img 
        src={image} 
        alt={name} 
        className="w-16 h-16 rounded-full mr-4" 
      />: <p>
      <span className="profile-intials p-[12px]">
          {firstName?.charAt(0).toUpperCase()}
          {lastName?.charAt(0).toUpperCase()}
      </span>
  </p>}
      <div>
        <h3 className="text-lg font-semibold">{name}</h3>
        <p className="text-sm text-gray-600">{role}</p>
        <a 
          href={`mailto:${email}`} 
          className="text-sm text-[#1B2A3D80] hover:underline"
        >
          {email}
        </a>
      </div>
    </div>
  );
};

export default ProfileCard;
